module.exports = __webpack_public_path__ + "static/media/iconCanvas01.607df081.svg";